import { AfterViewInit, Component, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EpcotConfig, MyBetsConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { HooksWireup } from '@frontend/sports/common/core/utils/hooks';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';
import { UserService } from '@frontend/sports/user/feature';
import { HtmlNode } from '@frontend/vanilla/core';
import { groupBy } from 'lodash-es';

import { MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { PrintPageBaseComponent } from '../../../print/print-base-page.component';
import { PrintDeviceType } from '../../../print/print.models';
import { MainMyBetsStrategy, MyBetsStrategy } from '../../services/my-bets-display.strategy';
import { MyBetsUtilService } from '../../services/my-bets-util.service';
import { MyBetsBetslipsResponse } from './my-bets-print.resolver';

export interface MyBetsBetslipGroup {
    date: Date;
    betslips: MyBetsBetSlip[];
}

@HooksWireup()
@Component({
    selector: 'ms-my-bets-print',
    templateUrl: 'my-bets-print.html',
    providers: [{ provide: MyBetsStrategy, useClass: MainMyBetsStrategy }],
    standalone: false,
})
export class MyBetsPrintComponent extends PrintPageBaseComponent<MyBetsBetslipsResponse> implements AfterViewInit {
    @HostBinding('class') className = 'mybets-redesign';

    betslipGroups: MyBetsBetslipGroup[] = [];
    myBetsListContext = new MyBetsListContext();
    userID: string | null;
    UserName: string | null;
    isEpcotEnabled = false;

    constructor(
        route: ActivatedRoute,
        htmlNodeService: HtmlNode,
        public sitecore: Sitecore,
        private userService: UserService,
        private epcotConfig: EpcotConfig,
        private myBetsUtilService: MyBetsUtilService,
        timer: TimerService,
        private mybetsConfig: MyBetsConfig,
    ) {
        super(route, htmlNodeService, timer);
        this.userID = this.userService.accountId;
        this.UserName = this.userService.username;
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    onRouteResolved(response: MyBetsBetslipsResponse): void {
        this.myBetsListContext.listType = BetslipListType.Settled;
        this.myBetsListContext.isPrintView = true;
        this.myBetsUtilService.setPrintState(true);
        this.hasErrors = response.hasErrors;
        if (this.printCommand !== PrintDeviceType.Default) {
            response.betslips = response.betslips.slice(0, this.mybetsConfig.printBetsThresholdForApp);
        }
        const dateGroups = groupBy(response.betslips, (bs) => bs.betPlacedDate.toISOString().slice(0, 10));
        this.betslipGroups = Object.keys(dateGroups).map((key) => {
            return {
                date: new Date(key),
                betslips: dateGroups[key],
            };
        });
    }
}
